(function() {
    function updateCartGiftStatus(isGift) {
        const giftStatus = isGift ? "REGALOSI" : "REGALONO";
        const updateData = JSON.stringify({
            attributes: {
                "Enviar como regalo": giftStatus
            }
        });

        fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: updateData
        });
    }

    function setupGiftModalAddButton() {
        const addGiftButton = document.querySelector("[data-cart-gift-modal-add]");
        if (addGiftButton) {
            addGiftButton.addEventListener("click", () => {
                const productId = addGiftButton.getAttribute("data-cart-gift-modal-product-id");
                addGiftButton.disabled = true;

                const addItemData = JSON.stringify({
                    items: [{
                        id: productId,
                        quantity: 1
                    }]
                });

                fetch(`${routes.cart_add_url}`, {
                    ...fetchConfig(),
                    body: addItemData
                })
                .then(() => window.location.reload());
            });
        }
    }

    function setupGiftOrderRadioButtons() {
        const giftOrderTrueRadio = document.querySelector("#order_as_gift_true");
        const giftOrderFalseRadio = document.querySelector("#order_as_gift_false");

        if (giftOrderTrueRadio && giftOrderFalseRadio) {
            giftOrderTrueRadio.addEventListener("click", () => {
                giftOrderTrueRadio.checked = true;
                giftOrderFalseRadio.checked = false;
                showGiftModal();
                updateCartGiftStatus(true);
            });

            giftOrderFalseRadio.addEventListener("click", () => {
                giftOrderTrueRadio.checked = false;
                giftOrderFalseRadio.checked = true;
                updateCartGiftStatus(false);
            });
        }
    }

    function showGiftModal() {
        const giftModal = document.getElementById("cartGiftModal");
        if (giftModal) {
            new bootstrap.Modal(giftModal).show();
        }
    }

    document.addEventListener("DOMContentLoaded", () => {
        setupGiftOrderRadioButtons();
        setupGiftModalAddButton();
    });

    document.addEventListener("cart-list-updated", () => {
        setupGiftOrderRadioButtons();
        setupGiftModalAddButton();
    });
})();